import React from "react";

import { ScrollingProvider } from "../context/ScrollingContext";

import MainSection from "../sections/home/MainSection";
// import AboutSection from "../sections/home/AboutSection";
import SubjectsSection from "../sections/home/CoursesSection/SubjectsSection";
import auth from "../services/authServices";
import LoggedInHome from "../sections/home/LoggedInHome";
import TeacherSection from "../sections/home/TeacherSection";
import FeatureSection from "../sections/home/FeatureSection";
import CtaStudent from "../sections/home/CtaStudent";
import CtaTeachers from "../sections/home/CtaTeachers";
import BookSection from "../sections/home/BookSection";
import HomeSectionLiveSessionSection from "../sections/home/HomeSectionLiveSessionSection";
import CategoriesSection from "../sections/home/CategoriesSection";
import PartnerSection from "../sections/home/PartnerSection";

const Home = () => {
    const token = auth.getToken();
    return (
        <>
            <ScrollingProvider>
                <MainSection />
                {/* <FeatureSection /> */}
                <CategoriesSection />
            </ScrollingProvider>

            <PartnerSection />
            <SubjectsSection />
            {/* {token && (
                <div className="py-10 mt-20">
                    <HomeSectionLiveSessionSection />{" "}
                </div>
            )}

            <SubjectsSection />

            {!token && <TeacherSection />}
            {!token && <CtaStudent />} */}
        </>
    );
};

export default Home;
